//Navigation bar gifs or img's can be imported here

import summerNavbarGif from "./summer/navbar.gif";
import winterNavbarGif from "./winter/navbar.gif";
import newyearNavbarGif from "./newyear/navbar.gif";
import republicDayNavbarGif from "./republic-day/navbar1.gif";
import holiNavbarGif from "./holi/navbar.gif";
import valentineNavbarGif from "./valentine/navbar.gif";
import monsoonNavbarGif from "./monsoon/navbar.gif";
import eidNavbarGif from "./eid/navbar.gif";
import dussheraNavbarGif from "./dussehra/navbar.gif";
import diwaliNavbarGif from "./diwali/navbar.gif";
import christmasNavbarGif from "./christmas/navbar.gif";
import independenceDayNavbarGif from "./independence-day/navbar.gif";


//footer gifs or img's can be imported here

import summerFooterGif from "./summer/footer.gif";
import winterFooterGif from "./winter/footer.gif";
import newyearFooterGif from "./newyear/footer.gif";
import republicDayFooterGif from "./republic-day/footer.gif";
import holiFooterGif from "./holi/footer.png";
import valentineFooterGif from "./valentine/footer.gif";
import monsoonFooterGif from "./monsoon/footer.gif";
import eidFooterGif from "./eid/footer.gif";
import dussheraFooterGif from "./dussehra/footer.gif";
import diwaliFooterGif from "./diwali/footer.gif";
import christmasFooterGif from "./christmas/footer.gif";
import independenceDayFooterGif from "./independence-day/footer.gif";

/*import summerHomeBanner from "./summer/home-banner.gif";
import winterHomeBanner from "./winter/home-banner.gif";
import newyearHomeBanner from "./newyear/home-banner.gif";
import republicDayHomeBanner from "./republic-day/home-banner.gif";
import holiHomeBanner from "./holi/home-banner.gif";
import valentineHomeBanner from "./valentine/home-banner.gif";
import monsoonHomeBanner from "./monsoon/home-banner.gif";
import eidHomeBanner from "./eid/home-banner.gif";
import dussheraHomeBanner from "./dussehra/home-banner.gif";
import diwaliHomeBanner from "./diwali/home-banner.gif";
import christmasHomeBanner from "./christmas/home-banner.gif";*/

//left and right images (or gifs) of different themes can be imported here

import valentineRight from "./valentine/right.png";
import valentineLeft from "./valentine/left.gif";

import summerLeft from "./summer/left.png";
import summerRight from "./summer/right.png";

import christmasRight from "./christmas/right.png";
import christmasLeft from "./christmas/left.gif";

import eidRight from "./eid/right.png";
import eidLeft from "./eid/left.png";

import winterRight from "./winter/right.png";
import winterLeft from "./winter/left.png";

import diwaliLeft from "./diwali/left.png";
import diwaliRight from "./diwali/right.png";

import dussheraLeft from "./dussehra/left.png";
import dussheraRight from "./dussehra/right.png";

import independenceRight from "./independence-day/right.webp"
import independenceLeft from "./independence-day/left.png"

import republicRight from "./republic-day/left.png"
import republicLeft from "./republic-day/right.gif"

import newyearRight from "./newyear/right1.gif"
import newyearLeft from "./newyear/left.png"

import holiLeft from "./holi/left.gif"
import holiRight from "./holi/right.gif"

import monsoonLeft from "./monsoon/left.gif"
import monsoonRight from "./monsoon/right.gif"

export const THEME_CONFIG = {
  summer: {
    key: "summer",
    name: "Summer",
    navbarGif: summerNavbarGif,
    footerGif: summerFooterGif,
    //homeBanners: [summerBanner1, summerBanner2],
    navbg:"#FDE8E4",
    footerBackground: "#EF3C23",
    rightDecoration: summerRight,
    leftDecoration: summerLeft,
    primary: "#FF9800",
    secondary: "#FFF8E1",
    textcolor: "#E65100",  
    offerText: "Your Summer Drive Starts Here",
  },
  winter: {
    key: "winter",
    name: "Winter",
    navbarGif: winterNavbarGif,
    footerGif: winterFooterGif,
    navbg:"#98e5ff",
    rightDecoration: winterRight,
    leftDecoration: winterLeft,
    //homeBanners: [winterBanner1, winterBanner2],
    footerBackground: "#5098b3",
    primary: "#0288D1",    // Deep frosty blue
    secondary: "#E1F5FE",  // Very light ice blue
    text: "#01579B",       // Dark navy for readability
    offerText: "Chilling deals have arrived",
  },
  
  newyear: {
    key: "newyear",
    name: "New Year",
    navbarGif: newyearNavbarGif,
    footerGif: newyearFooterGif,
    //homeBanners: [newyearHomeBanner],
    rightDecoration:newyearRight,
    leftDecoration:newyearLeft,
    navbg:"#9df9ef",
    footerBackground: "#d0bdf4",
    primary: "#2E7D32",
    secondary: "#F1F8E9",
    text: "#1B5E20",
    offerText: "Start the year with exciting new offers",
  },

  republicDay: {
    key: "republicDay",
    name: "Republic Day",
    navbarGif: republicDayNavbarGif,
    footerGif: republicDayFooterGif,
    //homeBanners: [republicDayHomeBanner],
    rightDecoration: republicRight,
    leftDecoration: republicLeft,
    navbg:"#FF9933",
    footerBackground: "#046A38",
    primary: "#FF6F00",
    secondary: "#FFFFFF",
    text: "#1B5E20",
    offerText: "Celebrate Republic Day with patriotic deals 🇮🇳",
  },

  holi: {
    key: "holi",
    name: "Holi",
    navbarGif: holiNavbarGif,
    footerGif: holiFooterGif,
    //homeBanners: [holiHomeBanner],
    rightDecoration:holiRight,
    leftDecoration:holiLeft,
    navbg:"#fff5d7",
    footerBackground: "#f75990",
    primary: "#8E24AA",
    secondary: "#FFF3E0",
    text: "#4A148C",
    offerText: "Splash into colorful Holi celebrations",
  },

  valentine: {
    key: "valentine",
    name: "Valentine",
    navbarGif: valentineNavbarGif,
    footerGif: valentineFooterGif,
    //homeBanners: [valentineHomeBanner],
    navbg:"#FFC5E6",
    rightDecoration: valentineRight,
    leftDecoration: valentineLeft,
    footerBackground: "#fe6bbe",
    primary: "#E91E63",
    secondary: "#FFF0F5",
    text: "#880E4F",
    offerText: "Celebrate love with special Valentine offers",
  },

  monsoon: {
    key: "monsoon",
    name: "Monsoon",
    navbarGif: monsoonNavbarGif,
    footerGif: monsoonFooterGif,
    rightDecoration: monsoonRight,
    leftDecoration: monsoonLeft,
    //homeBanners: [monsoonHomeBanner],
    footerBackground: " #8BA1AD",
    navbg:"#F1F1F1 ",
    primary: "#2196F3",
    secondary: "#F3F9FF",
    text: "#0D47A1",
    offerText: "Rainy season specials just for you",
  },

  independenceDay: {
    key: "independenceDay",
    name: "Independence Day",
    navbarGif: independenceDayNavbarGif,
    footerGif: independenceDayFooterGif,
    rightDecoration:independenceRight,
    leftDecoration: independenceLeft,
    //homeBanners: [independenceDayHomeBanner],
    navbg:"#FF9933",
    footerBackground: "#046A38",
    primary: "#F57C00",
    secondary: "#E8F5E9",
    text: "#1B5E20",
    offerText: "Freedom offers are here this Independence Day",
  },

  eid: {
    key: "eid",
    name: "Eid",
    navbarGif: eidNavbarGif,
    footerGif: eidFooterGif,
    //homeBanners: [eidHomeBanner],
    navbg:"#FFF8EC",
    footerBackground: "#005047",
    rightDecoration: eidRight,
    leftDecoration: eidLeft,
    primary: "#2E7D32",
    secondary: "#F1F8E9",
    text: "#1B5E20",
    offerText: "Eid Mubarak! Celebrate with exclusive offers",
  },

  dusshera: {
    key: "dusshera",
    name: "Dusshera",
    navbarGif: dussheraNavbarGif,
    footerGif: dussheraFooterGif,
    rightDecoration: dussheraRight,
    leftDecoration: dussheraLeft,
    //homeBanners: [dussheraHomeBanner],
    footerBackground: "#FF6600",
    navbg:"#EFBF04 ",
    primary: "#E65100",
    secondary: "#FFF8E1",
    text: "#BF360C",
    offerText: "Victory celebrations and festive savings",
  },

  diwali: {
    key: "diwali",
    name: "Diwali",
    navbarGif: diwaliNavbarGif,
    footerGif: diwaliFooterGif,
    //homeBanners: [diwaliHomeBanner],
    rightDecoration: diwaliRight,
    leftDecoration: diwaliLeft,
    navbg:"#EDDFBA",
    footerBackground: "#D23341",
    primary: "#FF6F00",
    secondary: "#FFF3E0",
    text: "#E65100",
    offerText: "Light up your celebrations with Diwali deals",
  },

  christmas: {
    key: "christmas",
    name: "Christmas",
    navbarGif: christmasNavbarGif,
    footerGif: christmasFooterGif,
    //homeBanners: [christmasHomeBanner],
    navbg:"#F5D2BE",
    footerBackground: "#046A38",
    rightDecoration: christmasRight,
    leftDecoration: christmasLeft,
    primary: "#C62828",
    secondary: "#F1F8E9",
    text: "#1B5E20",
    offerText: "Merry Christmas with magical holiday offers",
  },
}